import { useDispatch } from 'react-redux'
import { openModal } from '@/components/composed/Modal/actions'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { HelperSelectionFinancingProductModal } from '@/components/composed/modals'
import type { THelperSelectionFinancingProductModalProps } from '@/components/composed/modals/HelperSelectionFinancingProductModal/types'
import { useMount } from '@/utils/hooks'
import { DEFAULT_TIMEOUT_TO_OPEN_MODAL } from './constants'
import { isInputActive } from './helpers'
import type { THelperModalWithTimeoutProps } from './types'

addModalToWellKnown({ HelperSelectionFinancingProductModal })

export const HelperModalWithTimeout = ({
  title,
  alreadyShownSessionStorageKey,
  timeout = DEFAULT_TIMEOUT_TO_OPEN_MODAL,
  requestMapper,
}: THelperModalWithTimeoutProps) => {
  const dispatch = useDispatch()

  useMount(() => {
    let timeoutId: NodeJS.Timeout

    function handleTimeout() {
      const hasAlreadyBeenShown = sessionStorage.getItem(alreadyShownSessionStorageKey)

      if (!hasAlreadyBeenShown) {
        timeoutId = setTimeout(() => {
          const isInProcessOfFillingOutForm = isInputActive()

          if (!isInProcessOfFillingOutForm) {
            dispatch(
              openModal({
                options: { dialogId: 'HelperSelectionFinancingProductModal' },
                contentOptions: {
                  title,
                  requestMapper,
                } as THelperSelectionFinancingProductModalProps['options'],
              }),
            )

            sessionStorage.setItem(alreadyShownSessionStorageKey, 'true')
          } else {
            clearTimeout(timeoutId)
            handleTimeout()
          }
        }, timeout)
      }
    }

    handleTimeout()

    return () => clearTimeout(timeoutId)
  })

  return null
}
